// extracted by mini-css-extract-plugin
export var root = "R2iB";
export var rootBody = "btOg";
export var rootDescription = "Poee";
export var rootExternal = "eECp";
export var rootHeading = "CnfR";
export var rootHeadingCut = "okPu";
export var rootImage = "uObx";
export var rootPicture = "R+yj";